const Header = () => {
  return (
    <nav className="navbar navbar-expand-lg bg-light">
      <div className="container-fluid">
        <a className="navbar-brand ps-5" href=' '>CyWeather Forecast</a>
      </div>
    </nav>
  );
};

export default Header;
